import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const discourseConnectorsQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Elige el conector adecuado: 'No me gusta el café; ___, prefiero el té.'",
        options: ["sin embargo", "por lo tanto", "de hecho", "en cambio"],
        correctAnswerIndex: 3,
        explanation: "'En cambio' se utiliza para indicar una alternativa o una oposición con lo dicho anteriormente."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Completa la oración: '___ llueva, iremos al parque.'",
        options: ["Aunque", "A menos que", "Si", "Como"],
        correctAnswerIndex: 0,
        explanation: "'Aunque' se usa para introducir una idea contraria a lo esperado, pero que no impide lo que se va a decir."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Selecciona el conector correcto: 'Me gusta el cine; ___, no tengo tiempo para ir.'",
        options: ["por lo tanto", "sin embargo", "además", "en consecuencia"],
        correctAnswerIndex: 1,
        explanation: "'Sin embargo' se usa para contrastar dos ideas opuestas en una misma frase."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Elige la opción correcta: 'No entiendo cómo llegó tan tarde; ___, salió muy temprano de casa.'",
        options: ["de hecho", "por lo tanto", "sin embargo", "en cambio"],
        correctAnswerIndex: 2,
        explanation: "'Sin embargo' indica una contradicción entre dos situaciones aparentemente opuestas."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Completa la oración: '___ quiero descansar este fin de semana, no iré a la fiesta.'",
        options: ["Como", "Porque", "Si", "Aunque"],
        correctAnswerIndex: 1,
        explanation: "'Porque' se utiliza para dar una razón o causa que justifica lo que se dice a continuación."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Selecciona el conector adecuado: 'Me olvidé de comprar la leche; ___, no pude preparar el desayuno.'",
        options: ["por lo tanto", "sin embargo", "a pesar de", "por eso"],
        correctAnswerIndex: 0,
        explanation: "'Por lo tanto' se usa para introducir una consecuencia o resultado de lo dicho antes."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Elige el conector adecuado: 'Estudió mucho; ___, aprobó el examen.'",
        options: ["por lo tanto", "aunque", "sin embargo", "a pesar de"],
        correctAnswerIndex: 0,
        explanation: "'Por lo tanto' se usa para expresar la consecuencia de una acción previa."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Completa la frase: '___ te esfuerces, no vas a lograrlo.'",
        options: ["Aunque", "A menos que", "Por lo tanto", "Si"],
        correctAnswerIndex: 1,
        explanation: "'A menos que' introduce una condición que, si no se cumple, resultará en lo contrario de lo que se dice."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Selecciona el conector adecuado: '___ de que me guste la música clásica, prefiero el rock.'",
        options: ["A pesar", "Por lo tanto", "De hecho", "Sin embargo"],
        correctAnswerIndex: 0,
        explanation: "'A pesar' se usa para introducir una idea contraria a lo esperado o a una situación inicial."
    },
    {
        category: QuizCategory.DISCOURSE_CONNECTORS,
        questionText: "Elige el conector adecuado: '___ me ofrecieron un buen trabajo, decidí quedarme en mi ciudad.'",
        options: ["Aunque", "Por eso", "De hecho", "Sin embargo"],
        correctAnswerIndex: 0,
        explanation: "'Aunque' se usa para introducir una contradicción entre la oferta y la decisión tomada."
    }
];

export default discourseConnectorsQuestions;